// source: acompanha/transactions/v1/transactions.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var acompanha_common_v1_common_pb = require('../../../acompanha/common/v1/common_pb.js');
goog.object.extend(proto, acompanha_common_v1_common_pb);
var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
goog.exportSymbol('proto.acompanha.transactions.v1.CreateTransactionRequest', null, global);
goog.exportSymbol('proto.acompanha.transactions.v1.CreateTransactionResponse', null, global);
goog.exportSymbol('proto.acompanha.transactions.v1.DeleteTransactionRequest', null, global);
goog.exportSymbol('proto.acompanha.transactions.v1.GetTransactionRequest', null, global);
goog.exportSymbol('proto.acompanha.transactions.v1.GetTransactionResponse', null, global);
goog.exportSymbol('proto.acompanha.transactions.v1.ListTransactionsRequest', null, global);
goog.exportSymbol('proto.acompanha.transactions.v1.ListTransactionsResponse', null, global);
goog.exportSymbol('proto.acompanha.transactions.v1.ReconciliationDailyPoint', null, global);
goog.exportSymbol('proto.acompanha.transactions.v1.ReconciliationData', null, global);
goog.exportSymbol('proto.acompanha.transactions.v1.ReconciliationRequest', null, global);
goog.exportSymbol('proto.acompanha.transactions.v1.ReconciliationResponse', null, global);
goog.exportSymbol('proto.acompanha.transactions.v1.Transaction', null, global);
goog.exportSymbol('proto.acompanha.transactions.v1.UpdateTransactionRequest', null, global);
goog.exportSymbol('proto.acompanha.transactions.v1.UpdateTransactionResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.transactions.v1.Transaction = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.transactions.v1.Transaction, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.transactions.v1.Transaction.displayName = 'proto.acompanha.transactions.v1.Transaction';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.transactions.v1.ReconciliationDailyPoint = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.transactions.v1.ReconciliationDailyPoint, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.transactions.v1.ReconciliationDailyPoint.displayName = 'proto.acompanha.transactions.v1.ReconciliationDailyPoint';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.transactions.v1.ReconciliationData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.acompanha.transactions.v1.ReconciliationData.repeatedFields_, null);
};
goog.inherits(proto.acompanha.transactions.v1.ReconciliationData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.transactions.v1.ReconciliationData.displayName = 'proto.acompanha.transactions.v1.ReconciliationData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.transactions.v1.ListTransactionsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.acompanha.transactions.v1.ListTransactionsRequest.repeatedFields_, null);
};
goog.inherits(proto.acompanha.transactions.v1.ListTransactionsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.transactions.v1.ListTransactionsRequest.displayName = 'proto.acompanha.transactions.v1.ListTransactionsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.transactions.v1.ListTransactionsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.acompanha.transactions.v1.ListTransactionsResponse.repeatedFields_, null);
};
goog.inherits(proto.acompanha.transactions.v1.ListTransactionsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.transactions.v1.ListTransactionsResponse.displayName = 'proto.acompanha.transactions.v1.ListTransactionsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.transactions.v1.GetTransactionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.transactions.v1.GetTransactionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.transactions.v1.GetTransactionRequest.displayName = 'proto.acompanha.transactions.v1.GetTransactionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.transactions.v1.GetTransactionResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.transactions.v1.GetTransactionResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.transactions.v1.GetTransactionResponse.displayName = 'proto.acompanha.transactions.v1.GetTransactionResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.transactions.v1.CreateTransactionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.transactions.v1.CreateTransactionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.transactions.v1.CreateTransactionRequest.displayName = 'proto.acompanha.transactions.v1.CreateTransactionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.transactions.v1.CreateTransactionResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.transactions.v1.CreateTransactionResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.transactions.v1.CreateTransactionResponse.displayName = 'proto.acompanha.transactions.v1.CreateTransactionResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.transactions.v1.UpdateTransactionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.transactions.v1.UpdateTransactionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.transactions.v1.UpdateTransactionRequest.displayName = 'proto.acompanha.transactions.v1.UpdateTransactionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.transactions.v1.UpdateTransactionResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.transactions.v1.UpdateTransactionResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.transactions.v1.UpdateTransactionResponse.displayName = 'proto.acompanha.transactions.v1.UpdateTransactionResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.transactions.v1.DeleteTransactionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.transactions.v1.DeleteTransactionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.transactions.v1.DeleteTransactionRequest.displayName = 'proto.acompanha.transactions.v1.DeleteTransactionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.transactions.v1.ReconciliationRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.transactions.v1.ReconciliationRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.transactions.v1.ReconciliationRequest.displayName = 'proto.acompanha.transactions.v1.ReconciliationRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.transactions.v1.ReconciliationResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.transactions.v1.ReconciliationResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.transactions.v1.ReconciliationResponse.displayName = 'proto.acompanha.transactions.v1.ReconciliationResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.transactions.v1.Transaction.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.transactions.v1.Transaction.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.transactions.v1.Transaction} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.transactions.v1.Transaction.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
type: jspb.Message.getFieldWithDefault(msg, 2, ""),
amount: jspb.Message.getFieldWithDefault(msg, 3, 0),
deduction: jspb.Message.getFieldWithDefault(msg, 4, 0),
netAmount: jspb.Message.getFieldWithDefault(msg, 5, 0),
description: jspb.Message.getFieldWithDefault(msg, 6, ""),
paymentMethod: jspb.Message.getFieldWithDefault(msg, 7, ""),
orderId: jspb.Message.getFieldWithDefault(msg, 8, ""),
createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
updatedAt: (f = msg.getUpdatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
authorizationId: jspb.Message.getFieldWithDefault(msg, 11, ""),
source: jspb.Message.getFieldWithDefault(msg, 12, ""),
outcomeCategory: jspb.Message.getFieldWithDefault(msg, 13, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.transactions.v1.Transaction}
 */
proto.acompanha.transactions.v1.Transaction.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.transactions.v1.Transaction;
  return proto.acompanha.transactions.v1.Transaction.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.transactions.v1.Transaction} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.transactions.v1.Transaction}
 */
proto.acompanha.transactions.v1.Transaction.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setType(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAmount(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setDeduction(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setNetAmount(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setPaymentMethod(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrderId(value);
      break;
    case 9:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedAt(value);
      break;
    case 10:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdatedAt(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setAuthorizationId(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setSource(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setOutcomeCategory(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.transactions.v1.Transaction.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.transactions.v1.Transaction.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.transactions.v1.Transaction} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.transactions.v1.Transaction.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getType();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAmount();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getDeduction();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getNetAmount();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getPaymentMethod();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getOrderId();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getCreatedAt();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getUpdatedAt();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getAuthorizationId();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getSource();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getOutcomeCategory();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.acompanha.transactions.v1.Transaction.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.transactions.v1.Transaction} returns this
 */
proto.acompanha.transactions.v1.Transaction.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string type = 2;
 * @return {string}
 */
proto.acompanha.transactions.v1.Transaction.prototype.getType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.transactions.v1.Transaction} returns this
 */
proto.acompanha.transactions.v1.Transaction.prototype.setType = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int64 amount = 3;
 * @return {number}
 */
proto.acompanha.transactions.v1.Transaction.prototype.getAmount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.transactions.v1.Transaction} returns this
 */
proto.acompanha.transactions.v1.Transaction.prototype.setAmount = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 deduction = 4;
 * @return {number}
 */
proto.acompanha.transactions.v1.Transaction.prototype.getDeduction = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.transactions.v1.Transaction} returns this
 */
proto.acompanha.transactions.v1.Transaction.prototype.setDeduction = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int64 net_amount = 5;
 * @return {number}
 */
proto.acompanha.transactions.v1.Transaction.prototype.getNetAmount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.transactions.v1.Transaction} returns this
 */
proto.acompanha.transactions.v1.Transaction.prototype.setNetAmount = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional string description = 6;
 * @return {string}
 */
proto.acompanha.transactions.v1.Transaction.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.transactions.v1.Transaction} returns this
 */
proto.acompanha.transactions.v1.Transaction.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string payment_method = 7;
 * @return {string}
 */
proto.acompanha.transactions.v1.Transaction.prototype.getPaymentMethod = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.transactions.v1.Transaction} returns this
 */
proto.acompanha.transactions.v1.Transaction.prototype.setPaymentMethod = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string order_id = 8;
 * @return {string}
 */
proto.acompanha.transactions.v1.Transaction.prototype.getOrderId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.transactions.v1.Transaction} returns this
 */
proto.acompanha.transactions.v1.Transaction.prototype.setOrderId = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional google.protobuf.Timestamp created_at = 9;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.acompanha.transactions.v1.Transaction.prototype.getCreatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 9));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.acompanha.transactions.v1.Transaction} returns this
*/
proto.acompanha.transactions.v1.Transaction.prototype.setCreatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.transactions.v1.Transaction} returns this
 */
proto.acompanha.transactions.v1.Transaction.prototype.clearCreatedAt = function() {
  return this.setCreatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.transactions.v1.Transaction.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional google.protobuf.Timestamp updated_at = 10;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.acompanha.transactions.v1.Transaction.prototype.getUpdatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 10));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.acompanha.transactions.v1.Transaction} returns this
*/
proto.acompanha.transactions.v1.Transaction.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.transactions.v1.Transaction} returns this
 */
proto.acompanha.transactions.v1.Transaction.prototype.clearUpdatedAt = function() {
  return this.setUpdatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.transactions.v1.Transaction.prototype.hasUpdatedAt = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional string authorization_id = 11;
 * @return {string}
 */
proto.acompanha.transactions.v1.Transaction.prototype.getAuthorizationId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.transactions.v1.Transaction} returns this
 */
proto.acompanha.transactions.v1.Transaction.prototype.setAuthorizationId = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string source = 12;
 * @return {string}
 */
proto.acompanha.transactions.v1.Transaction.prototype.getSource = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.transactions.v1.Transaction} returns this
 */
proto.acompanha.transactions.v1.Transaction.prototype.setSource = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string outcome_category = 13;
 * @return {string}
 */
proto.acompanha.transactions.v1.Transaction.prototype.getOutcomeCategory = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.transactions.v1.Transaction} returns this
 */
proto.acompanha.transactions.v1.Transaction.prototype.setOutcomeCategory = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.transactions.v1.ReconciliationDailyPoint.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.transactions.v1.ReconciliationDailyPoint.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.transactions.v1.ReconciliationDailyPoint} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.transactions.v1.ReconciliationDailyPoint.toObject = function(includeInstance, msg) {
  var f, obj = {
date: jspb.Message.getFieldWithDefault(msg, 1, ""),
incomeTotal: jspb.Message.getFieldWithDefault(msg, 2, 0),
outcomeTotal: jspb.Message.getFieldWithDefault(msg, 3, 0),
withdrawalTotal: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.transactions.v1.ReconciliationDailyPoint}
 */
proto.acompanha.transactions.v1.ReconciliationDailyPoint.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.transactions.v1.ReconciliationDailyPoint;
  return proto.acompanha.transactions.v1.ReconciliationDailyPoint.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.transactions.v1.ReconciliationDailyPoint} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.transactions.v1.ReconciliationDailyPoint}
 */
proto.acompanha.transactions.v1.ReconciliationDailyPoint.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDate(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setIncomeTotal(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setOutcomeTotal(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setWithdrawalTotal(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.transactions.v1.ReconciliationDailyPoint.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.transactions.v1.ReconciliationDailyPoint.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.transactions.v1.ReconciliationDailyPoint} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.transactions.v1.ReconciliationDailyPoint.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDate();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getIncomeTotal();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getOutcomeTotal();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getWithdrawalTotal();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
};


/**
 * optional string date = 1;
 * @return {string}
 */
proto.acompanha.transactions.v1.ReconciliationDailyPoint.prototype.getDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.transactions.v1.ReconciliationDailyPoint} returns this
 */
proto.acompanha.transactions.v1.ReconciliationDailyPoint.prototype.setDate = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 income_total = 2;
 * @return {number}
 */
proto.acompanha.transactions.v1.ReconciliationDailyPoint.prototype.getIncomeTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.transactions.v1.ReconciliationDailyPoint} returns this
 */
proto.acompanha.transactions.v1.ReconciliationDailyPoint.prototype.setIncomeTotal = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 outcome_total = 3;
 * @return {number}
 */
proto.acompanha.transactions.v1.ReconciliationDailyPoint.prototype.getOutcomeTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.transactions.v1.ReconciliationDailyPoint} returns this
 */
proto.acompanha.transactions.v1.ReconciliationDailyPoint.prototype.setOutcomeTotal = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 withdrawal_total = 4;
 * @return {number}
 */
proto.acompanha.transactions.v1.ReconciliationDailyPoint.prototype.getWithdrawalTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.transactions.v1.ReconciliationDailyPoint} returns this
 */
proto.acompanha.transactions.v1.ReconciliationDailyPoint.prototype.setWithdrawalTotal = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.acompanha.transactions.v1.ReconciliationData.repeatedFields_ = [12];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.transactions.v1.ReconciliationData.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.transactions.v1.ReconciliationData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.transactions.v1.ReconciliationData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.transactions.v1.ReconciliationData.toObject = function(includeInstance, msg) {
  var f, obj = {
totalIncome: jspb.Message.getFieldWithDefault(msg, 1, 0),
totalOutcome: jspb.Message.getFieldWithDefault(msg, 2, 0),
balance: jspb.Message.getFieldWithDefault(msg, 3, 0),
transactionCount: jspb.Message.getFieldWithDefault(msg, 4, 0),
incomeCount: jspb.Message.getFieldWithDefault(msg, 5, 0),
outcomeCount: jspb.Message.getFieldWithDefault(msg, 6, 0),
averageTransaction: jspb.Message.getFieldWithDefault(msg, 7, 0),
expenseTotal: jspb.Message.getFieldWithDefault(msg, 8, 0),
withdrawalTotal: jspb.Message.getFieldWithDefault(msg, 9, 0),
expenseCount: jspb.Message.getFieldWithDefault(msg, 10, 0),
withdrawalCount: jspb.Message.getFieldWithDefault(msg, 11, 0),
dailyList: jspb.Message.toObjectList(msg.getDailyList(),
    proto.acompanha.transactions.v1.ReconciliationDailyPoint.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.transactions.v1.ReconciliationData}
 */
proto.acompanha.transactions.v1.ReconciliationData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.transactions.v1.ReconciliationData;
  return proto.acompanha.transactions.v1.ReconciliationData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.transactions.v1.ReconciliationData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.transactions.v1.ReconciliationData}
 */
proto.acompanha.transactions.v1.ReconciliationData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotalIncome(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotalOutcome(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setBalance(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTransactionCount(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setIncomeCount(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOutcomeCount(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAverageTransaction(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setExpenseTotal(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setWithdrawalTotal(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setExpenseCount(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setWithdrawalCount(value);
      break;
    case 12:
      var value = new proto.acompanha.transactions.v1.ReconciliationDailyPoint;
      reader.readMessage(value,proto.acompanha.transactions.v1.ReconciliationDailyPoint.deserializeBinaryFromReader);
      msg.addDaily(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.transactions.v1.ReconciliationData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.transactions.v1.ReconciliationData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.transactions.v1.ReconciliationData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.transactions.v1.ReconciliationData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTotalIncome();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getTotalOutcome();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getBalance();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getTransactionCount();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getIncomeCount();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getOutcomeCount();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getAverageTransaction();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
  f = message.getExpenseTotal();
  if (f !== 0) {
    writer.writeInt64(
      8,
      f
    );
  }
  f = message.getWithdrawalTotal();
  if (f !== 0) {
    writer.writeInt64(
      9,
      f
    );
  }
  f = message.getExpenseCount();
  if (f !== 0) {
    writer.writeInt32(
      10,
      f
    );
  }
  f = message.getWithdrawalCount();
  if (f !== 0) {
    writer.writeInt32(
      11,
      f
    );
  }
  f = message.getDailyList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      12,
      f,
      proto.acompanha.transactions.v1.ReconciliationDailyPoint.serializeBinaryToWriter
    );
  }
};


/**
 * optional int64 total_income = 1;
 * @return {number}
 */
proto.acompanha.transactions.v1.ReconciliationData.prototype.getTotalIncome = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.transactions.v1.ReconciliationData} returns this
 */
proto.acompanha.transactions.v1.ReconciliationData.prototype.setTotalIncome = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 total_outcome = 2;
 * @return {number}
 */
proto.acompanha.transactions.v1.ReconciliationData.prototype.getTotalOutcome = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.transactions.v1.ReconciliationData} returns this
 */
proto.acompanha.transactions.v1.ReconciliationData.prototype.setTotalOutcome = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 balance = 3;
 * @return {number}
 */
proto.acompanha.transactions.v1.ReconciliationData.prototype.getBalance = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.transactions.v1.ReconciliationData} returns this
 */
proto.acompanha.transactions.v1.ReconciliationData.prototype.setBalance = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 transaction_count = 4;
 * @return {number}
 */
proto.acompanha.transactions.v1.ReconciliationData.prototype.getTransactionCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.transactions.v1.ReconciliationData} returns this
 */
proto.acompanha.transactions.v1.ReconciliationData.prototype.setTransactionCount = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 income_count = 5;
 * @return {number}
 */
proto.acompanha.transactions.v1.ReconciliationData.prototype.getIncomeCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.transactions.v1.ReconciliationData} returns this
 */
proto.acompanha.transactions.v1.ReconciliationData.prototype.setIncomeCount = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int32 outcome_count = 6;
 * @return {number}
 */
proto.acompanha.transactions.v1.ReconciliationData.prototype.getOutcomeCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.transactions.v1.ReconciliationData} returns this
 */
proto.acompanha.transactions.v1.ReconciliationData.prototype.setOutcomeCount = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int64 average_transaction = 7;
 * @return {number}
 */
proto.acompanha.transactions.v1.ReconciliationData.prototype.getAverageTransaction = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.transactions.v1.ReconciliationData} returns this
 */
proto.acompanha.transactions.v1.ReconciliationData.prototype.setAverageTransaction = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional int64 expense_total = 8;
 * @return {number}
 */
proto.acompanha.transactions.v1.ReconciliationData.prototype.getExpenseTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.transactions.v1.ReconciliationData} returns this
 */
proto.acompanha.transactions.v1.ReconciliationData.prototype.setExpenseTotal = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional int64 withdrawal_total = 9;
 * @return {number}
 */
proto.acompanha.transactions.v1.ReconciliationData.prototype.getWithdrawalTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.transactions.v1.ReconciliationData} returns this
 */
proto.acompanha.transactions.v1.ReconciliationData.prototype.setWithdrawalTotal = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional int32 expense_count = 10;
 * @return {number}
 */
proto.acompanha.transactions.v1.ReconciliationData.prototype.getExpenseCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.transactions.v1.ReconciliationData} returns this
 */
proto.acompanha.transactions.v1.ReconciliationData.prototype.setExpenseCount = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional int32 withdrawal_count = 11;
 * @return {number}
 */
proto.acompanha.transactions.v1.ReconciliationData.prototype.getWithdrawalCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.transactions.v1.ReconciliationData} returns this
 */
proto.acompanha.transactions.v1.ReconciliationData.prototype.setWithdrawalCount = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * repeated ReconciliationDailyPoint daily = 12;
 * @return {!Array<!proto.acompanha.transactions.v1.ReconciliationDailyPoint>}
 */
proto.acompanha.transactions.v1.ReconciliationData.prototype.getDailyList = function() {
  return /** @type{!Array<!proto.acompanha.transactions.v1.ReconciliationDailyPoint>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.acompanha.transactions.v1.ReconciliationDailyPoint, 12));
};


/**
 * @param {!Array<!proto.acompanha.transactions.v1.ReconciliationDailyPoint>} value
 * @return {!proto.acompanha.transactions.v1.ReconciliationData} returns this
*/
proto.acompanha.transactions.v1.ReconciliationData.prototype.setDailyList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 12, value);
};


/**
 * @param {!proto.acompanha.transactions.v1.ReconciliationDailyPoint=} opt_value
 * @param {number=} opt_index
 * @return {!proto.acompanha.transactions.v1.ReconciliationDailyPoint}
 */
proto.acompanha.transactions.v1.ReconciliationData.prototype.addDaily = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 12, opt_value, proto.acompanha.transactions.v1.ReconciliationDailyPoint, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.acompanha.transactions.v1.ReconciliationData} returns this
 */
proto.acompanha.transactions.v1.ReconciliationData.prototype.clearDailyList = function() {
  return this.setDailyList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.acompanha.transactions.v1.ListTransactionsRequest.repeatedFields_ = [5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.transactions.v1.ListTransactionsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.transactions.v1.ListTransactionsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.transactions.v1.ListTransactionsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.transactions.v1.ListTransactionsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
pagination: (f = msg.getPagination()) && acompanha_common_v1_common_pb.PaginationRequest.toObject(includeInstance, f),
from: (f = msg.getFrom()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
to: (f = msg.getTo()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
type: jspb.Message.getFieldWithDefault(msg, 4, ""),
authorizationIdsList: (f = jspb.Message.getRepeatedField(msg, 5)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.transactions.v1.ListTransactionsRequest}
 */
proto.acompanha.transactions.v1.ListTransactionsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.transactions.v1.ListTransactionsRequest;
  return proto.acompanha.transactions.v1.ListTransactionsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.transactions.v1.ListTransactionsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.transactions.v1.ListTransactionsRequest}
 */
proto.acompanha.transactions.v1.ListTransactionsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new acompanha_common_v1_common_pb.PaginationRequest;
      reader.readMessage(value,acompanha_common_v1_common_pb.PaginationRequest.deserializeBinaryFromReader);
      msg.setPagination(value);
      break;
    case 2:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setFrom(value);
      break;
    case 3:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setTo(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setType(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.addAuthorizationIds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.transactions.v1.ListTransactionsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.transactions.v1.ListTransactionsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.transactions.v1.ListTransactionsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.transactions.v1.ListTransactionsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPagination();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      acompanha_common_v1_common_pb.PaginationRequest.serializeBinaryToWriter
    );
  }
  f = message.getFrom();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getTo();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getType();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getAuthorizationIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      5,
      f
    );
  }
};


/**
 * optional acompanha.common.v1.PaginationRequest pagination = 1;
 * @return {?proto.acompanha.common.v1.PaginationRequest}
 */
proto.acompanha.transactions.v1.ListTransactionsRequest.prototype.getPagination = function() {
  return /** @type{?proto.acompanha.common.v1.PaginationRequest} */ (
    jspb.Message.getWrapperField(this, acompanha_common_v1_common_pb.PaginationRequest, 1));
};


/**
 * @param {?proto.acompanha.common.v1.PaginationRequest|undefined} value
 * @return {!proto.acompanha.transactions.v1.ListTransactionsRequest} returns this
*/
proto.acompanha.transactions.v1.ListTransactionsRequest.prototype.setPagination = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.transactions.v1.ListTransactionsRequest} returns this
 */
proto.acompanha.transactions.v1.ListTransactionsRequest.prototype.clearPagination = function() {
  return this.setPagination(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.transactions.v1.ListTransactionsRequest.prototype.hasPagination = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.protobuf.Timestamp from = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.acompanha.transactions.v1.ListTransactionsRequest.prototype.getFrom = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.acompanha.transactions.v1.ListTransactionsRequest} returns this
*/
proto.acompanha.transactions.v1.ListTransactionsRequest.prototype.setFrom = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.transactions.v1.ListTransactionsRequest} returns this
 */
proto.acompanha.transactions.v1.ListTransactionsRequest.prototype.clearFrom = function() {
  return this.setFrom(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.transactions.v1.ListTransactionsRequest.prototype.hasFrom = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.Timestamp to = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.acompanha.transactions.v1.ListTransactionsRequest.prototype.getTo = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.acompanha.transactions.v1.ListTransactionsRequest} returns this
*/
proto.acompanha.transactions.v1.ListTransactionsRequest.prototype.setTo = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.transactions.v1.ListTransactionsRequest} returns this
 */
proto.acompanha.transactions.v1.ListTransactionsRequest.prototype.clearTo = function() {
  return this.setTo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.transactions.v1.ListTransactionsRequest.prototype.hasTo = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string type = 4;
 * @return {string}
 */
proto.acompanha.transactions.v1.ListTransactionsRequest.prototype.getType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.transactions.v1.ListTransactionsRequest} returns this
 */
proto.acompanha.transactions.v1.ListTransactionsRequest.prototype.setType = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * repeated string authorization_ids = 5;
 * @return {!Array<string>}
 */
proto.acompanha.transactions.v1.ListTransactionsRequest.prototype.getAuthorizationIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 5));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.acompanha.transactions.v1.ListTransactionsRequest} returns this
 */
proto.acompanha.transactions.v1.ListTransactionsRequest.prototype.setAuthorizationIdsList = function(value) {
  return jspb.Message.setField(this, 5, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.acompanha.transactions.v1.ListTransactionsRequest} returns this
 */
proto.acompanha.transactions.v1.ListTransactionsRequest.prototype.addAuthorizationIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 5, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.acompanha.transactions.v1.ListTransactionsRequest} returns this
 */
proto.acompanha.transactions.v1.ListTransactionsRequest.prototype.clearAuthorizationIdsList = function() {
  return this.setAuthorizationIdsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.acompanha.transactions.v1.ListTransactionsResponse.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.transactions.v1.ListTransactionsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.transactions.v1.ListTransactionsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.transactions.v1.ListTransactionsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.transactions.v1.ListTransactionsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
success: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
transactionsList: jspb.Message.toObjectList(msg.getTransactionsList(),
    proto.acompanha.transactions.v1.Transaction.toObject, includeInstance),
meta: (f = msg.getMeta()) && acompanha_common_v1_common_pb.PaginationMeta.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.transactions.v1.ListTransactionsResponse}
 */
proto.acompanha.transactions.v1.ListTransactionsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.transactions.v1.ListTransactionsResponse;
  return proto.acompanha.transactions.v1.ListTransactionsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.transactions.v1.ListTransactionsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.transactions.v1.ListTransactionsResponse}
 */
proto.acompanha.transactions.v1.ListTransactionsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 2:
      var value = new proto.acompanha.transactions.v1.Transaction;
      reader.readMessage(value,proto.acompanha.transactions.v1.Transaction.deserializeBinaryFromReader);
      msg.addTransactions(value);
      break;
    case 3:
      var value = new acompanha_common_v1_common_pb.PaginationMeta;
      reader.readMessage(value,acompanha_common_v1_common_pb.PaginationMeta.deserializeBinaryFromReader);
      msg.setMeta(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.transactions.v1.ListTransactionsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.transactions.v1.ListTransactionsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.transactions.v1.ListTransactionsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.transactions.v1.ListTransactionsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getTransactionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.acompanha.transactions.v1.Transaction.serializeBinaryToWriter
    );
  }
  f = message.getMeta();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      acompanha_common_v1_common_pb.PaginationMeta.serializeBinaryToWriter
    );
  }
};


/**
 * optional bool success = 1;
 * @return {boolean}
 */
proto.acompanha.transactions.v1.ListTransactionsResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.acompanha.transactions.v1.ListTransactionsResponse} returns this
 */
proto.acompanha.transactions.v1.ListTransactionsResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * repeated Transaction transactions = 2;
 * @return {!Array<!proto.acompanha.transactions.v1.Transaction>}
 */
proto.acompanha.transactions.v1.ListTransactionsResponse.prototype.getTransactionsList = function() {
  return /** @type{!Array<!proto.acompanha.transactions.v1.Transaction>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.acompanha.transactions.v1.Transaction, 2));
};


/**
 * @param {!Array<!proto.acompanha.transactions.v1.Transaction>} value
 * @return {!proto.acompanha.transactions.v1.ListTransactionsResponse} returns this
*/
proto.acompanha.transactions.v1.ListTransactionsResponse.prototype.setTransactionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.acompanha.transactions.v1.Transaction=} opt_value
 * @param {number=} opt_index
 * @return {!proto.acompanha.transactions.v1.Transaction}
 */
proto.acompanha.transactions.v1.ListTransactionsResponse.prototype.addTransactions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.acompanha.transactions.v1.Transaction, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.acompanha.transactions.v1.ListTransactionsResponse} returns this
 */
proto.acompanha.transactions.v1.ListTransactionsResponse.prototype.clearTransactionsList = function() {
  return this.setTransactionsList([]);
};


/**
 * optional acompanha.common.v1.PaginationMeta meta = 3;
 * @return {?proto.acompanha.common.v1.PaginationMeta}
 */
proto.acompanha.transactions.v1.ListTransactionsResponse.prototype.getMeta = function() {
  return /** @type{?proto.acompanha.common.v1.PaginationMeta} */ (
    jspb.Message.getWrapperField(this, acompanha_common_v1_common_pb.PaginationMeta, 3));
};


/**
 * @param {?proto.acompanha.common.v1.PaginationMeta|undefined} value
 * @return {!proto.acompanha.transactions.v1.ListTransactionsResponse} returns this
*/
proto.acompanha.transactions.v1.ListTransactionsResponse.prototype.setMeta = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.transactions.v1.ListTransactionsResponse} returns this
 */
proto.acompanha.transactions.v1.ListTransactionsResponse.prototype.clearMeta = function() {
  return this.setMeta(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.transactions.v1.ListTransactionsResponse.prototype.hasMeta = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.transactions.v1.GetTransactionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.transactions.v1.GetTransactionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.transactions.v1.GetTransactionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.transactions.v1.GetTransactionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
uuid: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.transactions.v1.GetTransactionRequest}
 */
proto.acompanha.transactions.v1.GetTransactionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.transactions.v1.GetTransactionRequest;
  return proto.acompanha.transactions.v1.GetTransactionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.transactions.v1.GetTransactionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.transactions.v1.GetTransactionRequest}
 */
proto.acompanha.transactions.v1.GetTransactionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUuid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.transactions.v1.GetTransactionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.transactions.v1.GetTransactionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.transactions.v1.GetTransactionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.transactions.v1.GetTransactionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string uuid = 1;
 * @return {string}
 */
proto.acompanha.transactions.v1.GetTransactionRequest.prototype.getUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.transactions.v1.GetTransactionRequest} returns this
 */
proto.acompanha.transactions.v1.GetTransactionRequest.prototype.setUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.transactions.v1.GetTransactionResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.transactions.v1.GetTransactionResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.transactions.v1.GetTransactionResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.transactions.v1.GetTransactionResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
success: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
transaction: (f = msg.getTransaction()) && proto.acompanha.transactions.v1.Transaction.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.transactions.v1.GetTransactionResponse}
 */
proto.acompanha.transactions.v1.GetTransactionResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.transactions.v1.GetTransactionResponse;
  return proto.acompanha.transactions.v1.GetTransactionResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.transactions.v1.GetTransactionResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.transactions.v1.GetTransactionResponse}
 */
proto.acompanha.transactions.v1.GetTransactionResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 2:
      var value = new proto.acompanha.transactions.v1.Transaction;
      reader.readMessage(value,proto.acompanha.transactions.v1.Transaction.deserializeBinaryFromReader);
      msg.setTransaction(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.transactions.v1.GetTransactionResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.transactions.v1.GetTransactionResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.transactions.v1.GetTransactionResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.transactions.v1.GetTransactionResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getTransaction();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.acompanha.transactions.v1.Transaction.serializeBinaryToWriter
    );
  }
};


/**
 * optional bool success = 1;
 * @return {boolean}
 */
proto.acompanha.transactions.v1.GetTransactionResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.acompanha.transactions.v1.GetTransactionResponse} returns this
 */
proto.acompanha.transactions.v1.GetTransactionResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional Transaction transaction = 2;
 * @return {?proto.acompanha.transactions.v1.Transaction}
 */
proto.acompanha.transactions.v1.GetTransactionResponse.prototype.getTransaction = function() {
  return /** @type{?proto.acompanha.transactions.v1.Transaction} */ (
    jspb.Message.getWrapperField(this, proto.acompanha.transactions.v1.Transaction, 2));
};


/**
 * @param {?proto.acompanha.transactions.v1.Transaction|undefined} value
 * @return {!proto.acompanha.transactions.v1.GetTransactionResponse} returns this
*/
proto.acompanha.transactions.v1.GetTransactionResponse.prototype.setTransaction = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.transactions.v1.GetTransactionResponse} returns this
 */
proto.acompanha.transactions.v1.GetTransactionResponse.prototype.clearTransaction = function() {
  return this.setTransaction(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.transactions.v1.GetTransactionResponse.prototype.hasTransaction = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.transactions.v1.CreateTransactionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.transactions.v1.CreateTransactionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.transactions.v1.CreateTransactionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.transactions.v1.CreateTransactionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
type: jspb.Message.getFieldWithDefault(msg, 1, ""),
amount: jspb.Message.getFieldWithDefault(msg, 2, 0),
netAmount: jspb.Message.getFieldWithDefault(msg, 3, 0),
deduction: jspb.Message.getFieldWithDefault(msg, 4, 0),
description: jspb.Message.getFieldWithDefault(msg, 5, ""),
paymentMethod: jspb.Message.getFieldWithDefault(msg, 6, ""),
orderId: jspb.Message.getFieldWithDefault(msg, 7, ""),
authorizationId: jspb.Message.getFieldWithDefault(msg, 8, ""),
source: jspb.Message.getFieldWithDefault(msg, 9, ""),
outcomeCategory: jspb.Message.getFieldWithDefault(msg, 10, ""),
createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.transactions.v1.CreateTransactionRequest}
 */
proto.acompanha.transactions.v1.CreateTransactionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.transactions.v1.CreateTransactionRequest;
  return proto.acompanha.transactions.v1.CreateTransactionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.transactions.v1.CreateTransactionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.transactions.v1.CreateTransactionRequest}
 */
proto.acompanha.transactions.v1.CreateTransactionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setType(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAmount(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setNetAmount(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setDeduction(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setPaymentMethod(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrderId(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setAuthorizationId(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setSource(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setOutcomeCategory(value);
      break;
    case 11:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.transactions.v1.CreateTransactionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.transactions.v1.CreateTransactionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.transactions.v1.CreateTransactionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.transactions.v1.CreateTransactionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getType();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAmount();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getNetAmount();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getDeduction();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getPaymentMethod();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getOrderId();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getAuthorizationId();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getSource();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getOutcomeCategory();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getCreatedAt();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string type = 1;
 * @return {string}
 */
proto.acompanha.transactions.v1.CreateTransactionRequest.prototype.getType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.transactions.v1.CreateTransactionRequest} returns this
 */
proto.acompanha.transactions.v1.CreateTransactionRequest.prototype.setType = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 amount = 2;
 * @return {number}
 */
proto.acompanha.transactions.v1.CreateTransactionRequest.prototype.getAmount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.transactions.v1.CreateTransactionRequest} returns this
 */
proto.acompanha.transactions.v1.CreateTransactionRequest.prototype.setAmount = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 net_amount = 3;
 * @return {number}
 */
proto.acompanha.transactions.v1.CreateTransactionRequest.prototype.getNetAmount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.transactions.v1.CreateTransactionRequest} returns this
 */
proto.acompanha.transactions.v1.CreateTransactionRequest.prototype.setNetAmount = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 deduction = 4;
 * @return {number}
 */
proto.acompanha.transactions.v1.CreateTransactionRequest.prototype.getDeduction = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.transactions.v1.CreateTransactionRequest} returns this
 */
proto.acompanha.transactions.v1.CreateTransactionRequest.prototype.setDeduction = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional string description = 5;
 * @return {string}
 */
proto.acompanha.transactions.v1.CreateTransactionRequest.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.transactions.v1.CreateTransactionRequest} returns this
 */
proto.acompanha.transactions.v1.CreateTransactionRequest.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string payment_method = 6;
 * @return {string}
 */
proto.acompanha.transactions.v1.CreateTransactionRequest.prototype.getPaymentMethod = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.transactions.v1.CreateTransactionRequest} returns this
 */
proto.acompanha.transactions.v1.CreateTransactionRequest.prototype.setPaymentMethod = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string order_id = 7;
 * @return {string}
 */
proto.acompanha.transactions.v1.CreateTransactionRequest.prototype.getOrderId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.transactions.v1.CreateTransactionRequest} returns this
 */
proto.acompanha.transactions.v1.CreateTransactionRequest.prototype.setOrderId = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string authorization_id = 8;
 * @return {string}
 */
proto.acompanha.transactions.v1.CreateTransactionRequest.prototype.getAuthorizationId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.transactions.v1.CreateTransactionRequest} returns this
 */
proto.acompanha.transactions.v1.CreateTransactionRequest.prototype.setAuthorizationId = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string source = 9;
 * @return {string}
 */
proto.acompanha.transactions.v1.CreateTransactionRequest.prototype.getSource = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.transactions.v1.CreateTransactionRequest} returns this
 */
proto.acompanha.transactions.v1.CreateTransactionRequest.prototype.setSource = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string outcome_category = 10;
 * @return {string}
 */
proto.acompanha.transactions.v1.CreateTransactionRequest.prototype.getOutcomeCategory = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.transactions.v1.CreateTransactionRequest} returns this
 */
proto.acompanha.transactions.v1.CreateTransactionRequest.prototype.setOutcomeCategory = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional google.protobuf.Timestamp created_at = 11;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.acompanha.transactions.v1.CreateTransactionRequest.prototype.getCreatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 11));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.acompanha.transactions.v1.CreateTransactionRequest} returns this
*/
proto.acompanha.transactions.v1.CreateTransactionRequest.prototype.setCreatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.transactions.v1.CreateTransactionRequest} returns this
 */
proto.acompanha.transactions.v1.CreateTransactionRequest.prototype.clearCreatedAt = function() {
  return this.setCreatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.transactions.v1.CreateTransactionRequest.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 11) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.transactions.v1.CreateTransactionResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.transactions.v1.CreateTransactionResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.transactions.v1.CreateTransactionResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.transactions.v1.CreateTransactionResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
success: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.transactions.v1.CreateTransactionResponse}
 */
proto.acompanha.transactions.v1.CreateTransactionResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.transactions.v1.CreateTransactionResponse;
  return proto.acompanha.transactions.v1.CreateTransactionResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.transactions.v1.CreateTransactionResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.transactions.v1.CreateTransactionResponse}
 */
proto.acompanha.transactions.v1.CreateTransactionResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.transactions.v1.CreateTransactionResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.transactions.v1.CreateTransactionResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.transactions.v1.CreateTransactionResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.transactions.v1.CreateTransactionResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool success = 1;
 * @return {boolean}
 */
proto.acompanha.transactions.v1.CreateTransactionResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.acompanha.transactions.v1.CreateTransactionResponse} returns this
 */
proto.acompanha.transactions.v1.CreateTransactionResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.transactions.v1.UpdateTransactionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.transactions.v1.UpdateTransactionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.transactions.v1.UpdateTransactionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.transactions.v1.UpdateTransactionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
uuid: jspb.Message.getFieldWithDefault(msg, 1, ""),
type: jspb.Message.getFieldWithDefault(msg, 2, ""),
amount: jspb.Message.getFieldWithDefault(msg, 3, 0),
netAmount: jspb.Message.getFieldWithDefault(msg, 4, 0),
deduction: jspb.Message.getFieldWithDefault(msg, 5, 0),
description: jspb.Message.getFieldWithDefault(msg, 6, ""),
paymentMethod: jspb.Message.getFieldWithDefault(msg, 7, ""),
orderId: jspb.Message.getFieldWithDefault(msg, 8, ""),
authorizationId: jspb.Message.getFieldWithDefault(msg, 9, ""),
source: jspb.Message.getFieldWithDefault(msg, 10, ""),
outcomeCategory: jspb.Message.getFieldWithDefault(msg, 11, ""),
createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.transactions.v1.UpdateTransactionRequest}
 */
proto.acompanha.transactions.v1.UpdateTransactionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.transactions.v1.UpdateTransactionRequest;
  return proto.acompanha.transactions.v1.UpdateTransactionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.transactions.v1.UpdateTransactionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.transactions.v1.UpdateTransactionRequest}
 */
proto.acompanha.transactions.v1.UpdateTransactionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUuid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setType(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAmount(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setNetAmount(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setDeduction(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setPaymentMethod(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrderId(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setAuthorizationId(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setSource(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setOutcomeCategory(value);
      break;
    case 12:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.transactions.v1.UpdateTransactionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.transactions.v1.UpdateTransactionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.transactions.v1.UpdateTransactionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.transactions.v1.UpdateTransactionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getType();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAmount();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getNetAmount();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getDeduction();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getPaymentMethod();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getOrderId();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getAuthorizationId();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getSource();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getOutcomeCategory();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getCreatedAt();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string uuid = 1;
 * @return {string}
 */
proto.acompanha.transactions.v1.UpdateTransactionRequest.prototype.getUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.transactions.v1.UpdateTransactionRequest} returns this
 */
proto.acompanha.transactions.v1.UpdateTransactionRequest.prototype.setUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string type = 2;
 * @return {string}
 */
proto.acompanha.transactions.v1.UpdateTransactionRequest.prototype.getType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.transactions.v1.UpdateTransactionRequest} returns this
 */
proto.acompanha.transactions.v1.UpdateTransactionRequest.prototype.setType = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int64 amount = 3;
 * @return {number}
 */
proto.acompanha.transactions.v1.UpdateTransactionRequest.prototype.getAmount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.transactions.v1.UpdateTransactionRequest} returns this
 */
proto.acompanha.transactions.v1.UpdateTransactionRequest.prototype.setAmount = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 net_amount = 4;
 * @return {number}
 */
proto.acompanha.transactions.v1.UpdateTransactionRequest.prototype.getNetAmount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.transactions.v1.UpdateTransactionRequest} returns this
 */
proto.acompanha.transactions.v1.UpdateTransactionRequest.prototype.setNetAmount = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int64 deduction = 5;
 * @return {number}
 */
proto.acompanha.transactions.v1.UpdateTransactionRequest.prototype.getDeduction = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.transactions.v1.UpdateTransactionRequest} returns this
 */
proto.acompanha.transactions.v1.UpdateTransactionRequest.prototype.setDeduction = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional string description = 6;
 * @return {string}
 */
proto.acompanha.transactions.v1.UpdateTransactionRequest.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.transactions.v1.UpdateTransactionRequest} returns this
 */
proto.acompanha.transactions.v1.UpdateTransactionRequest.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string payment_method = 7;
 * @return {string}
 */
proto.acompanha.transactions.v1.UpdateTransactionRequest.prototype.getPaymentMethod = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.transactions.v1.UpdateTransactionRequest} returns this
 */
proto.acompanha.transactions.v1.UpdateTransactionRequest.prototype.setPaymentMethod = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string order_id = 8;
 * @return {string}
 */
proto.acompanha.transactions.v1.UpdateTransactionRequest.prototype.getOrderId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.transactions.v1.UpdateTransactionRequest} returns this
 */
proto.acompanha.transactions.v1.UpdateTransactionRequest.prototype.setOrderId = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string authorization_id = 9;
 * @return {string}
 */
proto.acompanha.transactions.v1.UpdateTransactionRequest.prototype.getAuthorizationId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.transactions.v1.UpdateTransactionRequest} returns this
 */
proto.acompanha.transactions.v1.UpdateTransactionRequest.prototype.setAuthorizationId = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string source = 10;
 * @return {string}
 */
proto.acompanha.transactions.v1.UpdateTransactionRequest.prototype.getSource = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.transactions.v1.UpdateTransactionRequest} returns this
 */
proto.acompanha.transactions.v1.UpdateTransactionRequest.prototype.setSource = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string outcome_category = 11;
 * @return {string}
 */
proto.acompanha.transactions.v1.UpdateTransactionRequest.prototype.getOutcomeCategory = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.transactions.v1.UpdateTransactionRequest} returns this
 */
proto.acompanha.transactions.v1.UpdateTransactionRequest.prototype.setOutcomeCategory = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional google.protobuf.Timestamp created_at = 12;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.acompanha.transactions.v1.UpdateTransactionRequest.prototype.getCreatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 12));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.acompanha.transactions.v1.UpdateTransactionRequest} returns this
*/
proto.acompanha.transactions.v1.UpdateTransactionRequest.prototype.setCreatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.transactions.v1.UpdateTransactionRequest} returns this
 */
proto.acompanha.transactions.v1.UpdateTransactionRequest.prototype.clearCreatedAt = function() {
  return this.setCreatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.transactions.v1.UpdateTransactionRequest.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 12) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.transactions.v1.UpdateTransactionResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.transactions.v1.UpdateTransactionResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.transactions.v1.UpdateTransactionResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.transactions.v1.UpdateTransactionResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
success: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.transactions.v1.UpdateTransactionResponse}
 */
proto.acompanha.transactions.v1.UpdateTransactionResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.transactions.v1.UpdateTransactionResponse;
  return proto.acompanha.transactions.v1.UpdateTransactionResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.transactions.v1.UpdateTransactionResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.transactions.v1.UpdateTransactionResponse}
 */
proto.acompanha.transactions.v1.UpdateTransactionResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.transactions.v1.UpdateTransactionResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.transactions.v1.UpdateTransactionResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.transactions.v1.UpdateTransactionResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.transactions.v1.UpdateTransactionResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool success = 1;
 * @return {boolean}
 */
proto.acompanha.transactions.v1.UpdateTransactionResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.acompanha.transactions.v1.UpdateTransactionResponse} returns this
 */
proto.acompanha.transactions.v1.UpdateTransactionResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.transactions.v1.DeleteTransactionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.transactions.v1.DeleteTransactionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.transactions.v1.DeleteTransactionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.transactions.v1.DeleteTransactionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
uuid: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.transactions.v1.DeleteTransactionRequest}
 */
proto.acompanha.transactions.v1.DeleteTransactionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.transactions.v1.DeleteTransactionRequest;
  return proto.acompanha.transactions.v1.DeleteTransactionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.transactions.v1.DeleteTransactionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.transactions.v1.DeleteTransactionRequest}
 */
proto.acompanha.transactions.v1.DeleteTransactionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUuid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.transactions.v1.DeleteTransactionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.transactions.v1.DeleteTransactionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.transactions.v1.DeleteTransactionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.transactions.v1.DeleteTransactionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string uuid = 1;
 * @return {string}
 */
proto.acompanha.transactions.v1.DeleteTransactionRequest.prototype.getUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.transactions.v1.DeleteTransactionRequest} returns this
 */
proto.acompanha.transactions.v1.DeleteTransactionRequest.prototype.setUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.transactions.v1.ReconciliationRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.transactions.v1.ReconciliationRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.transactions.v1.ReconciliationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.transactions.v1.ReconciliationRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
from: (f = msg.getFrom()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
to: (f = msg.getTo()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
type: jspb.Message.getFieldWithDefault(msg, 3, ""),
q: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.transactions.v1.ReconciliationRequest}
 */
proto.acompanha.transactions.v1.ReconciliationRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.transactions.v1.ReconciliationRequest;
  return proto.acompanha.transactions.v1.ReconciliationRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.transactions.v1.ReconciliationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.transactions.v1.ReconciliationRequest}
 */
proto.acompanha.transactions.v1.ReconciliationRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setFrom(value);
      break;
    case 2:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setTo(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setType(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setQ(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.transactions.v1.ReconciliationRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.transactions.v1.ReconciliationRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.transactions.v1.ReconciliationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.transactions.v1.ReconciliationRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFrom();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getTo();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getType();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getQ();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional google.protobuf.Timestamp from = 1;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.acompanha.transactions.v1.ReconciliationRequest.prototype.getFrom = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.acompanha.transactions.v1.ReconciliationRequest} returns this
*/
proto.acompanha.transactions.v1.ReconciliationRequest.prototype.setFrom = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.transactions.v1.ReconciliationRequest} returns this
 */
proto.acompanha.transactions.v1.ReconciliationRequest.prototype.clearFrom = function() {
  return this.setFrom(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.transactions.v1.ReconciliationRequest.prototype.hasFrom = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.protobuf.Timestamp to = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.acompanha.transactions.v1.ReconciliationRequest.prototype.getTo = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.acompanha.transactions.v1.ReconciliationRequest} returns this
*/
proto.acompanha.transactions.v1.ReconciliationRequest.prototype.setTo = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.transactions.v1.ReconciliationRequest} returns this
 */
proto.acompanha.transactions.v1.ReconciliationRequest.prototype.clearTo = function() {
  return this.setTo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.transactions.v1.ReconciliationRequest.prototype.hasTo = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string type = 3;
 * @return {string}
 */
proto.acompanha.transactions.v1.ReconciliationRequest.prototype.getType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.transactions.v1.ReconciliationRequest} returns this
 */
proto.acompanha.transactions.v1.ReconciliationRequest.prototype.setType = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string q = 4;
 * @return {string}
 */
proto.acompanha.transactions.v1.ReconciliationRequest.prototype.getQ = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.transactions.v1.ReconciliationRequest} returns this
 */
proto.acompanha.transactions.v1.ReconciliationRequest.prototype.setQ = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.transactions.v1.ReconciliationResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.transactions.v1.ReconciliationResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.transactions.v1.ReconciliationResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.transactions.v1.ReconciliationResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
success: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
data: (f = msg.getData()) && proto.acompanha.transactions.v1.ReconciliationData.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.transactions.v1.ReconciliationResponse}
 */
proto.acompanha.transactions.v1.ReconciliationResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.transactions.v1.ReconciliationResponse;
  return proto.acompanha.transactions.v1.ReconciliationResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.transactions.v1.ReconciliationResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.transactions.v1.ReconciliationResponse}
 */
proto.acompanha.transactions.v1.ReconciliationResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 2:
      var value = new proto.acompanha.transactions.v1.ReconciliationData;
      reader.readMessage(value,proto.acompanha.transactions.v1.ReconciliationData.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.transactions.v1.ReconciliationResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.transactions.v1.ReconciliationResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.transactions.v1.ReconciliationResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.transactions.v1.ReconciliationResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.acompanha.transactions.v1.ReconciliationData.serializeBinaryToWriter
    );
  }
};


/**
 * optional bool success = 1;
 * @return {boolean}
 */
proto.acompanha.transactions.v1.ReconciliationResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.acompanha.transactions.v1.ReconciliationResponse} returns this
 */
proto.acompanha.transactions.v1.ReconciliationResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional ReconciliationData data = 2;
 * @return {?proto.acompanha.transactions.v1.ReconciliationData}
 */
proto.acompanha.transactions.v1.ReconciliationResponse.prototype.getData = function() {
  return /** @type{?proto.acompanha.transactions.v1.ReconciliationData} */ (
    jspb.Message.getWrapperField(this, proto.acompanha.transactions.v1.ReconciliationData, 2));
};


/**
 * @param {?proto.acompanha.transactions.v1.ReconciliationData|undefined} value
 * @return {!proto.acompanha.transactions.v1.ReconciliationResponse} returns this
*/
proto.acompanha.transactions.v1.ReconciliationResponse.prototype.setData = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.transactions.v1.ReconciliationResponse} returns this
 */
proto.acompanha.transactions.v1.ReconciliationResponse.prototype.clearData = function() {
  return this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.transactions.v1.ReconciliationResponse.prototype.hasData = function() {
  return jspb.Message.getField(this, 2) != null;
};


goog.object.extend(exports, proto.acompanha.transactions.v1);
